module.exports = __webpack_public_path__ + "static/media/press-thumb-02.b69567a4.jpg";